export default "__VITE_ASSET__BJt9nxEf__";